<script>
import {Bar} from "vue-chartjs";

export default {
  name: "YearOverviewGraph",
  extends: Bar,
  props: {
    graph: {},
  },
  data() {
    return {
      Graph: this.graph,
    };
  },
  methods: {
    renderYearOverviewChart() {
      this.renderChart(
          {
            labels: this.graph.labels,
            datasets: [
              {
                label: "Neutraal",
                pointStyle: "rectRounded",
                pointRadius: 4,
                pointBackgroundColor: "rgb(128, 128, 128)",
                borderColor: "rgb(128, 128, 128)",
                backgroundColor: "rgb(128, 128, 128, 0.3)",
                data: this.graph.neutralData,
              },
              {
                label: "Positief",
                pointStyle: "rectRounded",
                pointRadius: 4,
                pointBackgroundColor: "rgb(22, 205, 190)",
                borderColor: "rgb(22, 205, 190)",
                backgroundColor: "rgb(22, 205, 190 0.3)",
                data: this.graph.positiveData,
              },
              {
                label: "Negatief",
                pointStyle: "rectRounded",
                pointRadius: 4,
                pointBackgroundColor: "rgba(117, 17, 19)",
                borderColor: "rgba(117, 17, 19)",
                backgroundColor: "rgba(117, 17, 19)",
                data: this.graph.negativeData,
              },
            ],
          },
          {
            responsive: true, maintainAspectRatio: false, scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [{
                stacked: true
              }],
              fontColor: 'white'
            }
          }
      );
    },
  },
  mounted() {
    this.renderYearOverviewChart();
  },
  watch: {
    graph: function () {
      this.renderYearOverviewChart();
    },
  },
};
</script>
